module.exports = __webpack_public_path__ + "media/images/foodpanda-logo-1befeb26c97ce593cc09be68d9e0c0ec.webp";